export default {"src":"/_next/static/media/HTM.26b06d18.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};